import React from 'react';
import { BlogPostTemplate } from '../components/Blog/BlogPostTemplate';
import blogData from '../data/blog/en/is-your-ex-a-covert-narcissist.json';
import { BlogPostData } from '../types/blog';
export function BlogPostCovertNarcissist() {
  return <BlogPostTemplate content={blogData as BlogPostData} data-id="element-3940" />;
}